module.exports = __webpack_public_path__ + "media/images/type3-88df6aa99d8fc1c3fa98994ad6f5d3e6.png";